import { render, staticRenderFns } from "./LedgerUserList.vue?vue&type=template&id=84a5b484&"
import script from "./LedgerUserList.vue?vue&type=script&lang=js&"
export * from "./LedgerUserList.vue?vue&type=script&lang=js&"
import style0 from "./LedgerUserList.vue?vue&type=style&index=0&id=84a5b484&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports